import { Fragment, useState } from "react";
import { Outlet, useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import styles from "./layout.module.css";
import TopNav from "./top-nav/TopNav";
import BottomNavigation from "./bottom-navigation/BottomNavigation";
import NavigationDrawer from "./navigation-drawer/NavigationDrawer";
import BottomSheet from "../conponents/BottomSheet/BottomSheet";
import CreateMenu from "../conponents/CreateMenu/CreateMenu";
import UpgradeBottomSheet from "../conponents/UpgradeBottomSheet/UpgradeBottomSheet";
import { selectCars } from "../redux/car/car-slice";
import { getSubscriptionInfo } from "../services/functions.js";
import ServiceLimitCarBottomSheet from "../conponents/ServiceLimitCarBottomSheet/ServiceLimitCarBottomSheet.jsx";



const Layout = () => {

    const navigate = useNavigate();

    const location = useLocation();

    const user = useSelector(
        state => state.user.user
    );

    const cars = useSelector(selectCars);

    const subscription = getSubscriptionInfo(

        user
    
    );

    const [

        limitCar,

        setLimitCar,

    ] = useState(false);

    const [

        showUpgrade,

        setShowUpgrade,

    ] = useState(false);

    const [

        drawerOpen,

        setDrawerOpen,

    ] = useState(false);

    const [

        createOpen,

        setCreateOpen,

    ] = useState(false);

    const openDrawer = () =>
        setDrawerOpen(true);

    const closeDrawer = () =>
        setDrawerOpen(false);

    const openCreate = () =>
        setCreateOpen(true);

    const closeCreate = () =>
        setCreateOpen(false);

    const handleLogout = () => {

        // console.log("Logout");

        // dispatch(logout());

        navigate("/login");

    };

    const getActiveTab = () => {

        const path = location.pathname;
    
        if (path === "/") return "home";
    
        if (
            // path.startsWith("/add-car") ||
            path.startsWith("/operate-edit") ||
            path.startsWith("/add-service") ||
            path.startsWith("/all-services")
        ) {
    
            return "cars";
    
        }
    
        if (
            path.startsWith("/edit-expense") ||
            path.startsWith("/add-expense") ||
            path.startsWith("/all-expense")
        ) {
    
            return "more";
    
        }
    
        return "";
    
    };

    return (

        <Fragment>

            <div className={styles.layout}>

                <NavigationDrawer

                    open={drawerOpen}

                    onClose={closeDrawer}

                    user={user}

                    onNavigate={(path) => {

                        closeDrawer();

                        if(path==="/add-car" && subscription.plan === "free"){

                            if(cars.length >= 1){
                
                                setShowUpgrade(true);
                
                                return;
                
                            }
            
                        }

                        navigate(path);

                    }}

                    onChangeCar={() => {

                        closeDrawer();

                        console.log("Change Active Car");

                    }}

                    onLogout={handleLogout}

                />

                <div className={styles.content}>

                    <TopNav

                        user={user}

                        onMenuClick={openDrawer}

                    />

                    <main className={styles.main}>

                        <Outlet />

                    </main>

                </div>

            </div>

            <BottomNavigation

                active={getActiveTab()}

                onHome={() =>

                    navigate("/")

                }

                onCars={() =>

                    navigate("/all-services")

                }

                onCreate={openCreate}

                onMore={() =>

                    navigate("/all-expense")

                }

            />

            <BottomSheet

                open={createOpen}

                title="ثبت اطلاعات"

                onClose={closeCreate}

            >

                <CreateMenu

                    onNavigate={(path) => {

                        closeCreate();

                        if(path==="/add-car" && cars.length >= 5){
                
                            setLimitCar(true);
                
                            return;

                        }

                        if(path==="/add-car" && subscription.plan === "free"){

                            if(cars.length >= 1){
                
                                setShowUpgrade(true);
                
                                return;
                
                            }
            
                        }

                        navigate(path);

                    }}

                />

            </BottomSheet>

            <UpgradeBottomSheet

                open={showUpgrade}

                title="محدودیت خودرو"

                message="در نسخه رایگان فقط امکان ثبت یک خودرو وجود دارد."

                onClose={() =>

                    setShowUpgrade(false)

                }

            />

            <ServiceLimitCarBottomSheet

                open={limitCar}

                onClose={()=>setLimitCar(false)}

            />

        </Fragment>

    );

};

export default Layout;